/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Filename_PlaceholderInputs */

const en_manual_qc_filename_placeholder = /** @type {(inputs: Manual_Qc_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`issues-export`)
};

const fr_manual_qc_filename_placeholder = /** @type {(inputs: Manual_Qc_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`incidents-export`)
};

const de_manual_qc_filename_placeholder = /** @type {(inputs: Manual_Qc_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Themen-Export`)
};

const it_manual_qc_filename_placeholder = /** @type {(inputs: Manual_Qc_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`problemi-esportazione`)
};

const ru_manual_qc_filename_placeholder = /** @type {(inputs: Manual_Qc_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`вопросы-экспорт`)
};

const es_manual_qc_filename_placeholder = /** @type {(inputs: Manual_Qc_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`problemas de exportación`)
};

const zh_cn2_manual_qc_filename_placeholder = /** @type {(inputs: Manual_Qc_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`问题导出`)
};

const ja_manual_qc_filename_placeholder = /** @type {(inputs: Manual_Qc_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題-エクスポート`)
};

const hi_manual_qc_filename_placeholder = /** @type {(inputs: Manual_Qc_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुद्दे-निर्यात`)
};

const pt_pt2_manual_qc_filename_placeholder = /** @type {(inputs: Manual_Qc_Filename_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`problemas-exportação`)
};

/**
* | output |
* | --- |
* | "issues-export" |
*
* @param {Manual_Qc_Filename_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_filename_placeholder = /** @type {((inputs?: Manual_Qc_Filename_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Filename_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_filename_placeholder(inputs)
	if (locale === "de") return de_manual_qc_filename_placeholder(inputs)
	if (locale === "it") return it_manual_qc_filename_placeholder(inputs)
	if (locale === "ru") return ru_manual_qc_filename_placeholder(inputs)
	if (locale === "es") return es_manual_qc_filename_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_filename_placeholder(inputs)
	if (locale === "ja") return ja_manual_qc_filename_placeholder(inputs)
	if (locale === "hi") return hi_manual_qc_filename_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_filename_placeholder(inputs)
	return en_manual_qc_filename_placeholder(inputs)
});